import { render, staticRenderFns } from "./activityTypeForm.vue?vue&type=template&id=90cd59e8"
import script from "./activityTypeForm.vue?vue&type=script&lang=js"
export * from "./activityTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports